const routesUrls = {
  createFirstCampaign: (campaignType = ':campaignType') => `/campaign/create/${campaignType}`,
  influencer: {

  },
  business: {
    createPage: (phase = ':phase?') => `/page/create/${phase}`,
    createUnlockWallet: (handle = ':handle') => `/page/${handle}/unlock-wallet`,
    createCampaign: (handle = ':handle', campaignType = ':type_or_id', tab = ':tab?') => {
      const parts = [
        'page',
        handle,
        'campaign',
        'create',
        campaignType,
        tab,
      ];

      return `/${parts.filter(val => val !== undefined || val !== '').join('/')}`;
    },
  },
};

export default routesUrls;
